module.exports = __webpack_public_path__ + "img/AquassistBilling.9890171e.svg";